import * as React from 'react';
const CloseIcon = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.478 5.522a.5.5 0 0 1 0 .707L10.708 10l3.77 3.771a.5.5 0 1 1-.707.707L10 10.709l-3.771 3.77a.5.5 0 1 1-.707-.707l3.771-3.77L5.522 6.23a.5.5 0 0 1 .707-.707L10 9.293l3.771-3.771a.5.5 0 0 1 .707 0"
      fill="currentColor"
    />
  </svg>
);
export default CloseIcon;
